// import { extendTailwindMerge } from 'tailwind-merge';

// Identity function to configure prettier class sorting in tw template literals
export const tw = (strings: TemplateStringsArray, ...values: any[]) => String.raw({ raw: strings }, ...values);

// Tailwind Merge customization
// export const twMerge = extendTailwindMerge({
//   extend: {
//     classGroups: {
//       'font-size': [
//         {
//           text: [
//             ...
//           ],
//         },
//       ],
//     },
//   },
// });
